import { render } from "./EventCard.vue?vue&type=template&id=1644e2d8&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=1644e2d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1644e2d8"

export default script